@if (registerSuccess()) {
  <ct-lib-info-banner type="success" class="register-success">
    <p>{{ 'jobboard.platform.auth.register.success-message' | transloco }}</p>
  </ct-lib-info-banner>
} @else {
  <form class="my-0" [formGroup]="registerForm" (ngSubmit)="onRegisterFormSubmit()">
    <div class="form-group" [class.invalid]="email.invalid && registerFormSubmitAttempt()">
      <input
        class="form-control"
        type="email"
        [placeholder]="'jobboard.platform.auth.register.email' | transloco"
        [formControl]="email"
        autocomplete="email"
      />
      <div class="validation">
        @if (email.errors?.['required']) {
          <p>{{ 'ct-library.validation.required' | transloco }}</p>
        }
        @if (email.errors?.['email'] || email.errors?.['pattern']) {
          <p>{{ 'ct-library.validation.email' | transloco }}</p>
        }
      </div>
    </div>
    <div class="form-group captcha-group" [class.invalid]="captchaCode.invalid && registerFormSubmitAttempt()">
      <div #friendlyCaptcha class="captcha-host"></div>
      <div class="validation">
        @if (captchaCode.errors?.['required']) {
          <p>{{ 'ct-library.validation.required' | transloco }}</p>
        }
      </div>
    </div>
    <div class="form-group privacy-accept">
      <div class="d-flex align-items-center gap-2">
        <input
          class="form-control my-0"
          type="checkbox"
          id="platform-legal-accept"
          [checked]="termsAccepted()"
          (change)="termsAccepted.set(!termsAccepted())"
        />
        <label for="platform-legal-accept">
          <p>
            {{ 'jobboard.platform.auth.register.checkbox-label' | transloco }}
            <a class="privacy-link" href="https://catch.hr/tos" target="_blank" (click)="$event.stopPropagation()">
              {{ 'jobboard.platform.auth.register.checkbox-link-terms' | transloco }}
            </a>
            &
            <a
              class="privacy-link"
              href="https://catch.hr/privacy-policy"
              target="_blank"
              (click)="$event.stopPropagation()"
            >
              {{ 'jobboard.platform.auth.register.checkbox-link-privacy' | transloco }}
            </a>
          </p>
        </label>
      </div>
    </div>
    <div class="form-group privacy-accept">
      <div class="d-flex align-items-center gap-2">
        <input
          class="form-control my-0"
          type="checkbox"
          id="platform-talenthub-accept"
          [checked]="talenthubAccepted()"
          (change)="talenthubAccepted.set(!talenthubAccepted())"
        />
        <label for="platform-talenthub-accept">
          <p class="talenthub-label">
            <span>{{ 'jobboard.platform.auth.register.talenthub-label' | transloco }}</span>
            <ct-lib-help-tooltip
              [value]="'jobboard.platform.auth.register.talenthub-info' | transloco"
              position="top"
            ></ct-lib-help-tooltip>
          </p>
        </label>
      </div>
    </div>
    <app-button
      variant="primary"
      htmlType="submit"
      [disabled]="!termsAccepted()"
      [loading]="registerAttempt()"
      [disableOnNoConnection]="true"
      [fullWidth]="true"
    >
      {{ 'jobboard.platform.auth.register.submit' | transloco }}
    </app-button>
  </form>
}
